// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* stylelint-disable design-system/ensure-design-token-usage */
.CgMywzdhGpOqcU {
  position: absolute;
  z-index: 6;
  top: 16px;
  right: 16px;
}
.GwoGYiqj30H6gL {
  width: fit-content;
  min-width: 95px;
  height: 40px;
  border-radius: 100px;
  background-color: #0c66e4;
  color: #ffffff;
  font-size: 16px;
}
.GwoGYiqj30H6gL:hover {
  background-color: #0055cc;
  color: #ffffff;
}
.GwoGYiqj30H6gL:active {
  background-color: #09326c;
  color: #ffffff;
}
.GwoGYiqj30H6gL span {
  margin: 13px 0 12px 3px;
}
`, ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"container": `CgMywzdhGpOqcU`,
	"button": `GwoGYiqj30H6gL`
};
export default ___CSS_LOADER_EXPORT___;
